import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "./ExitSurveyModal.scss";

/**
 * Exit Survey Confirmation Modal
 * Displays a confirmation dialog when user attempts to exit the survey
 */
const ExitSurveyModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation(["survey"]);

  if (!isOpen) return null;

  return (
    <div className="exit-survey-modal">
      <div className="exit-survey-modal__overlay" onClick={onConfirm} />
      <div className="exit-survey-modal__content">
        <button
          className="exit-survey-modal__close"
          onClick={onConfirm}
          type="button"
          aria-label={t("exitSurveyModal.closeAriaLabel")}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="exit-survey-modal__body">
          <h2 className="exit-survey-modal__title">
            {t("exitSurveyModal.title")}
          </h2>
          <p className="exit-survey-modal__description">
            {t("exitSurveyModal.description")}
          </p>

          <div className="exit-survey-modal__actions">
            <button
              className="exit-survey-modal__button exit-survey-modal__button--secondary"
              onClick={onClose}
              type="button"
            >
              {t("exitSurveyModal.leaveButton")}
            </button>
            <button
              className="exit-survey-modal__button exit-survey-modal__button--primary"
              onClick={onConfirm}
              type="button"
            >
              {t("exitSurveyModal.stayButton")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ExitSurveyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ExitSurveyModal;
